import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export const IGNORE_SKUS_QUERY_KEY = ["klant-inlichten", "ignore-skus-lookup"] as const;

const IGNORE_PRODUCT_NAME_FILTERS = ["%roerstok%", "%roerhoutje%", "%roerhout%"];

export const useIgnoredSkus = () => {
  const query = useQuery({
    queryKey: IGNORE_SKUS_QUERY_KEY,
    staleTime: 30 * 60 * 1000,
    gcTime: 60 * 60 * 1000,
    queryFn: async (): Promise<Set<string>> => {
      const orFilter = IGNORE_PRODUCT_NAME_FILTERS.map(
        (value) => `producttitle.ilike.${value}`,
      ).join(",");

      const { data, error } = await supabase
        .from("orders_live_ls")
        .select("sku, producttitle")
        .or(orFilter)
        .not("sku", "is", null)
        .limit(1000);

      if (error) throw error;

      const ignoredSkus = new Set<string>();

      for (const row of (data ?? []) as Array<{ sku: string | null; producttitle: string | null }>) {
        const sku = row.sku?.trim();
        const title = row.producttitle?.toLowerCase() ?? "";

        if (!sku) continue;
        if (title.includes("roerstok") || title.includes("roerhout")) {
          ignoredSkus.add(sku);
        }
      }

      return ignoredSkus;
    },
  });

  return {
    ignoredSkus: query.data ?? new Set<string>(),
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: query.refetch,
  };
};
